<template>
  <div
    class="px-5 pb-4 animate-pulse"
    aria-hidden="true"
  >
    <!-- ── Header ─────────────────────────────────────────────────────── -->
    <header class="mb-6">
      <!-- Back link -->
      <div class="flex mb-3">
        <div class="h-4 w-36 bg-gray-100 rounded" />
      </div>

      <!-- Avatar · Title + status · Actions -->
      <div class="flex flex-wrap md:flex-nowrap items-start gap-2 mb-1">
        <div class="h-14 w-14 rounded-full bg-gray-200 shrink-0 self-center" />

        <div class="flex-1 space-y-2 pt-1">
          <div class="h-8 w-64 bg-gray-200 rounded" />
          <div class="h-5 w-20 bg-gray-100 rounded-full" />
        </div>

        <div class="flex flex-wrap gap-4 w-full md:w-auto justify-end">
          <div class="flex gap-2">
            <div class="h-9 w-36 bg-gray-200 rounded-lg" />
            <div class="h-9 w-24 bg-gray-100 rounded-lg" />
          </div>
          <div class="flex gap-1.5">
            <div class="h-9 w-9 bg-gray-100 rounded-lg" />
            <div class="h-9 w-9 bg-gray-100 rounded-lg" />
          </div>
        </div>
      </div>

      <!-- Tabs + save button -->
      <div class="flex flex-wrap gap-4 py-4">
        <div class="flex gap-1 me-auto overflow-hidden">
          <div
            v-for="i in 7"
            :key="i"
            class="h-7 w-20 bg-gray-100 rounded shrink-0"
          />
        </div>
        <div class="h-9 w-32 bg-gray-200 rounded-lg" />
      </div>
    </header>

    <!-- ── Content blocks (two-column grid approximation) ─────────────── -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <!-- Identity (avatar + 8 fields) -->
      <div class="p-6 rounded-lg border border-gray-200 bg-white shadow-sm space-y-5">
        <div class="h-5 w-40 bg-gray-200 rounded" />
        <div class="h-16 w-16 rounded-full bg-gray-100" />
        <div class="grid grid-cols-2 gap-4">
          <div
            v-for="i in 8"
            :key="i"
            class="col-span-1 space-y-1.5"
          >
            <div class="h-3.5 w-20 bg-gray-100 rounded" />
            <div class="h-9 w-full bg-gray-100 rounded-lg" />
          </div>
        </div>
      </div>

      <!-- Addresses (3 rows) -->
      <div class="p-6 rounded-lg border border-gray-200 bg-white shadow-sm space-y-4">
        <div class="h-5 w-28 bg-gray-200 rounded" />
        <div
          v-for="i in 3"
          :key="i"
          class="flex items-start justify-between gap-2 py-1"
        >
          <div class="flex-1 space-y-1.5">
            <div class="h-4 w-3/4 bg-gray-100 rounded" />
            <div class="h-3 w-24 bg-gray-100 rounded" />
          </div>
          <div class="h-5 w-20 bg-gray-100 rounded-full" />
        </div>
      </div>
    </div>
  </div>
</template>
